// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import Content from "~/content";
import { _ } from "~/i18n";

/**
 * Specializovany content, ktery prekryva jiny obsah. Diky tomu lze mit vice contentu
 * aktivnich naraz.
 * Od bezneho se lisi tim, ze v ramci sve aktivace ostatni nedeaktivuje, ale
 * jen docasne skryva (volanim jejich .hide()).
 */
export default class ContentOverlay extends Content {
	/**
	 * Krom odebrani z pole aktivnich contentu jeste zobrazime nami skryteho predchudce
	 */
	deactivate() {
		if (!this.isActive()) {
			return this;
		}

		const content = super.deactivate();

		if (Mapy.active.length >= 1) {
			Mapy.active[0].show();
		}

		this.hide();

		return content;
	}

	/**
	 * Predchudce nedeaktivujeme, jen skryvame
	 */
	// eslint-disable-next-line class-methods-use-this
	_deactivatePrevious() {
		// pokud je otevrena galerie a klikneme napriklad na bod v mape pro otevreni jineho detailu, musime zajistit, aby se i galerie (jakykoliv content.full nebo dalsi overlay) zavrela
		// v soucasne chvili je overlay jen detail a pres nej dalsi overlay (i kdyz treba full) (tedy max. dva overlaye pres sebe),
		// proto to osetreni tady - muze tedy nastat jen v pripade otevreneho detailu a pres nej jeste jednoho overlaye (legenda), nebo content.full
		if (Mapy.active.length > 1) {
			Mapy.active[0].hide();
		}
		if (Mapy.active.length > 0) {
			Mapy.active[0].hide();
		}
		Mapy.getComponent("dimcurator").removeError();
	}

	show() {
		this._appendCloseButton();

		return super.show();
	}

	hide() {
		this._removeCloseButton();

		return super.hide();
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	_clickClose(event) {
		this.deactivate();
		Mapy.getComponent("history").save();
	}

	/* volitelne muze dostat titulek pro back button */
	_appendCloseButton() {
		this._setCloseButtonTitle();
	}

	/* nastavi title pro close button podle toho jaky stav je ve chvili volani aktivni
	a zohlednoi ze aktivni muze byt i overlay
	prednostne pouzije titulek ktery je funkci predan
	*/
	_setCloseButtonTitle(titleInput) {
		let title = "";
		const index = Mapy.active[1] ? 1 : 0;

		if (Mapy.active[index] instanceof ContentOverlay) {
			title = titleInput || _("back");
		} else if (!title) {
			title = Mapy.getComponent("stateswitch").getStateName();
		}
		this._setCloseButtonText(title);
	}

	_buildCloseButton() {
		this._dom.closeButtonText = node("span");
		this._dom.closeButton = node("button", { className: "back" });
		this._dom.closeButton.appendChild(this._dom.closeButtonText);
		this._setCloseButtonText(_("back"));
		this._dom.closeButton.addEventListener("click", this._clickClose.bind(this), false);
	}

	_setCloseButtonText(text) {
		this._dom.closeButtonText.innerHTML = text;
	}

	_removeCloseButton() {
		if (this._dom.closeButton) {
			this._dom.closeButton.remove();
		}
	}
}
